import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from "react-confirm-alert";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { getTrans as t } from "../../../Localization/translations";
import AddInvoiceService from "../../../services/billing/createInvoiceService";
import Helper from "../../../Helper";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";

function CreateInvoices() {
  const locale = localStorage.getItem('locale')

  const [due_date, setDue_Date] = useState(new Date());
  const [total_amount, setTotal_Amount] = useState(0);
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState("");
  const [transaction_type, setTransaction_type] = useState("Fee");
  const [loading, setLoading] = useState(false);
  const [billing_address, setBillingAddress] = useState("");
  const [extrafiledinvoice, setExtraFiled] = useState([]);
  const [invoice_series, setInvoiceSeries] = useState("");
  const [payment_method, setPayment_method] = useState("");
  const [filedinvoice, setFiledInvoice] = useState([
    { attribute0: "" },
    { attribute1: "" },
    { attribute2: "" },
    { attribute3: "" },
    { attribute4: "" },
    { attribute5: "" },
    { attribute6: "" },
    { attribute7: "" },
    { attribute8: "" },
    { attribute9: "" },
    { attribute10: "" },
    { attribute11: "" },
    { attribute12: "" },
    { attribute13: "" },
    { attribute14: "" },
  ]);
  const [successful, setSuccessful] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [inputvalue2, setValue2] = useState("");

  const [rowsData, setRowsData] = useState([]);

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleFields = () => {
    setIsExpanded(!isExpanded);
  };

  const [feedefination, setFeeDefination] = useState([]);
  // const FeeDefination = () => {
  //   let url =
  //     API + "contracts/feedefination-view/?feename=Manual Invoice&&active=Yes";
  //   axios
  //     .get(url, { headers: authHeader() })
  //     .then((response) => setFeeDefination(response.data))
  // };
  const FeeDefination = () => {
    let url = API + "expenses/fee-types/";
    axios.get(url, { headers: authHeader() })
        .then((response) => setFeeDefination(response.data))
  };

  useEffect(() => {
    FeeDefination();
  }, []);

  const addTableRows = () => {
    const rowsInput = {
      LineNumber: "",
      fee_type: "",
      description: "",
      amount: 0,
      tax: 0,
      total: 0,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    totalInvoiceAmount();
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    const amount = parseFloat(rowsInput[index].amount) || 0;
    const tax = parseFloat(rowsInput[index].tax) || 0;
    rowsInput[index].total = amount + tax;
    setRowsData(rowsInput);
    totalInvoiceAmount();
  };

  const totalInvoiceAmount = () => {
    let total = 0;
    let tax = 0
    Object.entries(rowsData).forEach(([key, value]) => {
      if (value.tax === "") {
        tax = 0
      }
      else {
        tax = value.tax
      }
      total =
        parseFloat(total) + parseFloat(value.amount) + parseFloat(tax);
    });
    setTotal_Amount(total);
  };

  const handelInputChange2 = (value1) => {
    setValue2(value1);
  };
  const handelChange2 = (value1) => {
    setSelectedValue2(value1);

    // ✅ Create customer object manually
    const customerObj = {
      id: value1.party,
      customer_name: value1.customer_name,
    };

    // ✅ Set selected customer
    setSelectedValue(customerObj);

    // ✅ IMPORTANT: inject into options
    setOptions([customerObj]);

    // ✅ reset form
    reset({
      selectedValue2: value1,
      selectedValue: customerObj,
    });
  };


  const handelDue_Date = (value) => {
    setDue_Date(value);
    reset({
      duedate: value,
    });
  };

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API +
        `contracts/contractsactive/filter/?id=${inputValue2}&&customer_id=${selectedValue ? selectedValue.id : ""
        }`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange1 = (value) => {
    if (value !== null) {
      setSelectedValue(value);
      loadInitialOptions(value.id);
      reset({
        selectedValue: value,
      });
    } else {
      setSelectedValue(null);
      reset({
        selectedValue: null,
      });
    }
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async (customer) => {
    const responseJSON = await axios.get(
      API + `parties/vendor/?party_type=Customer&&customer_name=${customer}`,
      { headers: authHeader() }
    );
    setOptions(responseJSON.data.data);
  };

  useEffect(() => {
    if (selectedValue2 === null) {
      setBillingAddress("");
    }
  }, [selectedValue2]);

  const getAddress = async () => {
    const responseJSON = await axios.get(
      API + `contracts/contract-getAddress/${selectedValue2.contract_number}/`,
      { headers: authHeader() }
    );
    return setBillingAddress(responseJSON.data.address_name);
  };

  const invoice_number_method = async () => {
    const responseJSON = await axios
      .get(API + `billing/invoice_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setInvoiceSeries(response.data.details);
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update Invoice Setting",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/additionalsettings"),
              },
            ],
          });
        }
      })
  };

  useEffect(() => {
    if (selectedValue2 !== null) {
      getAddress();
    }
    invoice_number_method();
  }, [selectedValue2]);

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existinvoice);
    })
  };

  useEffect(() => {
    getExtrafiled();
    addTableRows();
    reset({
      duedate: new Date(),
      amount: rowsData.amount
    });
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...filedinvoice];
    rowsInput[index][name] = value;
    setFiledInvoice(rowsInput);
  };

  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);
  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddInvoiceService.addInvoice(
        selectedValue2.id,
        Helper.DatePicker(due_date),
        comments,
        notes,
        transaction_type,
        total_amount,
        rowsData,
        filedinvoice,
        payment_method
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            setDisable(false);
            navigate("/billing/editinvoices", { state: response.data.id });
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setLoading(false);
          setDisable(false);
        }
      }).catch((error) => {
        toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })

      });
    }
  };

  const handelClick = () => {
    navigate("/billing");
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <div>
            <h5>{t("Create New Invoices")}</h5>
            <h6>
              <Link to="/billing" className="tc">
                {t("Invoices")}
              </Link>{" "}
              / <span>{t("New Invoice")}</span>{" "}
            </h6>
            <div className="show_invoice">
              <div className="row">
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-body">
                      <div className="success"></div>
                      <Form
                        role="form text-left"
                        onSubmit={handleSubmit(handleRegister)}
                        ref={form}
                        action="."
                        method="POST"
                        id="addPartyForm"
                      >
                        {
                          <>
                            <input
                              type="hidden"
                              value=""
                              id="invoiceid"
                              name="invoiceid"
                            />
                            <input
                              type="hidden"
                              value=""
                              id="invoiceno"
                              name="invoiceno"
                            />
                            <div className="row">
                              <div className="">
                                <label className="col-lg-6 col-form-label required">{t("Receipt Method")} <Tooltip content={t("ReceiptMethod_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-lg-12 form-group">
                                  <select
                                    {...register("payment_method", { required: "Receipt Method is required" })}
                                    className="form-control input-lg"
                                    name="payment_method"
                                    value={payment_method}
                                    onChange={(e) => setPayment_method(e.target.value)}
                                  >
                                    <option value="">Select Method</option>
                                    {
                                      locale === "en_US" ?
                                        <>
                                          <option value="Check">Check</option>
                                          <option value="Cash">Cash</option>
                                          <option value="Card">Card</option>
                                          <option value="ACH">ACH</option>
                                        </>
                                        :
                                        <>
                                          <option value="Cheque">Cheque</option>
                                          <option value="Cash">Cash</option>
                                          <option value="Card">Card</option>
                                          <option value="DirectDebit" >Direct Debit</option>
                                        </>
                                    }
                                  </select>
                                  <div className="invalid-feedback d-block">
                                    {errors.payment_method && errors.payment_method.message}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6">
                                <div className="form-group row">
                                  <label className="col-lg-6 col-form-label required">
                                    {t("Customer Name")}{" "}
                                    <Tooltip
                                      content={t("CustomerName_Tooltip")}
                                    >
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <AsyncSelect
                                      {...register("selectedValue", { required: true })}
                                      defaultOptions
                                      isClearable
                                      value={selectedValue}   // ✅ THIS IS KEY
                                      options={options}       // ✅ MUST HAVE
                                      placeholder="Search for Customer"
                                      getOptionLabel={(e) => e.customer_name}
                                      getOptionValue={(e) => e.id}   // ✅ MUST BE ID
                                      loadOptions={loadOptions}
                                      onChange={handelChange1}
                                    />
                                    <div className="invalid-feedback">
                                      {errors.selectedValue &&
                                        "Customer Name is required"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-6">
                                <div className="form-group row">
                                  <label className="col-lg-6 col-form-label required">
                                    {t("Contract Number")}{" "}
                                    <Tooltip
                                      content={t("ContractNumber_Tooltip")}
                                    >
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <AsyncSelect
                                      {...register("selectedValue2", {
                                        required: true,
                                      })}
                                      defaultOptions
                                      isClearable
                                      value={selectedValue2}
                                      placeholder={t(
                                        "Search for Contract(%for All)"
                                      )}
                                      getOptionLabel={(e) => e.contract_number}
                                      getOptionValue={(e) => e.contract_number}
                                      loadOptions={loadOptions2}
                                      onInputChange={handelInputChange2}
                                      onChange={handelChange2}
                                      name="selectedValue2"
                                    ></AsyncSelect>
                                    <div className="invalid-feedback">
                                      {errors.selectedValue2 &&
                                        "Contract Number is required"}
                                    </div>
                                    <input
                                      type="hidden"
                                      id="contract_status"
                                      value="Active"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-6">
                                <div className="form-group row">
                                  <label className="col-lg-12 col-form-label required">
                                    {t("Bill to Address")}{" "}
                                    <Tooltip
                                      content={t("BilltoAddress_Tooltip")}
                                    >
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <span id="bill_to">{billing_address}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-12">
                                <div className="form-group row">
                                  <label className="col-lg-12 col-form-label">
                                    {t("Description")}{" "}
                                    <Tooltip content={t("Description_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <textarea
                                      className="form-control"
                                      id="description"
                                      name="description"
                                      onChange={(e) =>
                                        setComments(e.target.value)
                                      }
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-12">
                                <div className="form-group row">
                                  <label className="col-lg-12 col-form-label">
                                    {t("Notes")}{" "}
                                    <Tooltip content={t("Notes_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <textarea
                                      className="form-control"
                                      id="description"
                                      name="notes"
                                      onChange={(e) => setNotes(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <div className="col-xl-6">
                                    <label className="col-lg-4 col-form-label text-left ">
                                      {t("Transaction Type")}{" "}
                                      <Tooltip
                                        content={t("TransactionType_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <select
                                      className="form-control"
                                      value={transaction_type}
                                      name="transactiontype"
                                      onChange={(e) =>
                                        setTransaction_type(e.target.value)
                                      }
                                    >
                                      <option value="">
                                        {t("Select Transaction Type")}
                                      </option>
                                      <option value="Fee">{t("Fee")}</option>
                                      <option value="Rent">{t("Rent")}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive">
                              <div className="row pt-3">
                                <div className="col-xl-6">
                                  <label className="col-form-label">
                                    {t("Items")}
                                  </label>
                                </div>
                                <div className="col-xl-6">
                                  <div className="text-right ">
                                    <button
                                      type="button"
                                      className="btn btn-outline-success"
                                      onClick={addTableRows}
                                    >
                                      + {t("ADD")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <table
                                id="invoice"
                                className="table table-nowrap mb-0"
                              >
                                <thead>
                                  <th>
                                    {t("Line Number")}{" "}
                                    <Tooltip content={t("LineNumber_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Fee Type")}{" "}
                                    <Tooltip content={t("Feetype_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Description")}{" "}
                                    <Tooltip content={t("Description_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Amount")}{" "}
                                    <Tooltip content={t("Amount_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Tax")}{" "}
                                    <Tooltip content={t("Tax_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Total")}{" "}
                                    <Tooltip content={t("Total_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                </thead>
                                <tbody>
                                  {rowsData.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("LIne Number")}
                                          {" "} <Tooltip content={t("LineNumber_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          {index + 1}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Fee Type")}
                                          {" "}  <Tooltip content={t("Feetype_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          <select
                                            // id="frequency"
                                            typeof="text"
                                            className="form-control"
                                            value={data.fee_type}
                                            disabled={transaction_type === "Rent" ? true : false}
                                            onChange={(evnt) =>
                                              handleChange(index, evnt)
                                            }
                                            name="fee_type"
                                          >
                                            <option value="">Select Fee type</option>
                                            {/* {feedefination.map((key) => (
                                              <option
                                                key={key.id}
                                                value={key.fee_name}
                                              >
                                                {key.fee_name}
                                              </option>
                                            ))} */}
                                            {feedefination.map((key) => (
                                                <option key={key.value} value={key.value}>{key.label}</option>
                                            ))}
                                          </select>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Description")}
                                          {" "} <Tooltip content="Description">
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          <input
                                            type="text"
                                            placeholder="Description"
                                            value={data.description}
                                            onChange={(evnt) =>
                                              handleChange(index, evnt)
                                            }
                                            name="description"
                                            className="form-control"
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Amount")}
                                          {" "} <Tooltip content={t("Amount_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          <input
                                            // {...register(`amount`, {
                                            //   required: false,
                                            // })}
                                            {...register("amount", {
                                              required: "amount is required",
                                              validate: {
                                                positive: (v) => (parseInt(v) > 0 || "Only positive numbers are allowed"),
                                              },
                                            })}
                                            type="text"
                                            value={data.amount}
                                            onChange={(evnt) =>
                                              handleChange(index, evnt)
                                            }
                                            name="amount"
                                            className="form-control required no-spinner"
                                          />
                                          <div className="invalid-feedback">
                                            {errors.amount &&
                                              errors.amount.message}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Tax")}
                                          {" "}  <Tooltip content={t("Tax_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          <input
                                            {...register(`tax`, {
                                              required: false,
                                            })}
                                            type="number"
                                            min='0'
                                            step='.01'
                                            disabled
                                            value={data.tax}
                                            onChange={(evnt) =>
                                              handleChange(index, evnt)
                                            }
                                            name="tax"
                                            className="form-control required"
                                          />
                                          <div className="invalid-feedback">
                                            {errors.tax && "Tax is required"}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Total")}
                                          {" "}<Tooltip content={t("Total_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </div>
                                        <div>
                                          <input
                                            type="number"
                                            value={data.total}
                                            onChange={(evnt) =>
                                              handleChange(index, evnt)
                                            }
                                            name="total"
                                            className="form-control no-spinner"
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <button
                                          className="btn btn-outline-danger "
                                          onClick={() => deleteTableRows(index)}
                                        >
                                          x
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            {extrafiledinvoice.length === 0 ? (
                              ""
                            ) : (
                              <h5
                                className="tc mt-4 cursor-pointer"
                                onClick={toggleFields}
                              >
                                {t("Additional Information")}{" "}
                                {isExpanded === true ? (
                                  <FaAngleUp />
                                ) : (
                                  <FaAngleDown />
                                )}
                              </h5>
                            )}
                            {isExpanded === true && (
                              <div className="form-group row">
                                {extrafiledinvoice.map((key, index) => (
                                  <div
                                    className={
                                      key.enable === "True" ? "col-sm-6" : null
                                    }
                                  >
                                    <>
                                      <label
                                        style={{
                                          display:
                                            key.enable === "True"
                                              ? true
                                              : "none",
                                        }}
                                        className="col-form-label"
                                      >
                                        {" "}
                                        {key.label}{" "}
                                        <Tooltip content={key.label}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <input
                                        style={{
                                          display:
                                            key.enable === "True"
                                              ? true
                                              : "none",
                                        }}
                                        className="form-control mb-1"
                                        name={"attribute" + index}
                                        type={key.datatype}
                                        placeholder={key.label}
                                        onChange={(e) =>
                                          onChangeextrafileds(e, index)
                                        }
                                      />
                                    </>
                                  </div>
                                ))}
                              </div>
                            )}
                            <div className="text-left py-3">
                              <button
                                style={{ display: "none" }}
                                type="button"
                                className="complete_invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Complete")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handelClick}
                                className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Cancel")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="submit"
                                disabled={disable}
                                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                              >
                                {loading === false ? (
                                  t("Save")
                                ) : (
                                  <ButtonLoading />
                                )}
                              </button>
                              &nbsp;&nbsp;
                            </div>
                          </>
                        }
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn}
                        />
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card">
                    <div className="card-body">
                      <label className="col-lg-8 form-label tc">
                        {t("Invoice No")}
                      </label>
                      <label className="md-6 text-right">-</label>
                      <div className="row">
                        <Form
                          role="form text-left"
                          onSubmit={handleSubmit(handleRegister)}
                          ref={form}
                          action="."
                          method="POST"
                          id="addPartyForm"
                        >
                          {
                            <>
                              <div className="col-xl-12">
                                <div className="form-group row">
                                  <label className="col-lg-12 col-form-label required">
                                    {t("Due Date")}{" "}
                                    <Tooltip content={t("DueDate_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <DatePicker
                                      {...register("duedate", {
                                        required: true,
                                      })}
                                      className="form-control datepick"
                                      selected={due_date}
                                      onChange={(e) => handelDue_Date(e)}
                                      name="duedate"
                                      placeholderText={"mm/dd/yyyy"}
                                      showYearDropdown // year show and scrolldown alos
                                      scrollableYearDropdown
                                      showMonthDropdown
                                      dropdownMode="select"
                                    />
                                    <div className="invalid-feedback">
                                      {errors.duedate &&
                                        "Due Date  is required"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Invoice Amount")}{" "}
                                      <Tooltip
                                        content={t("InvoiceAmount_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-12">
                                      <input
                                        disabled
                                        type="text"
                                        className="form-control"
                                        name="invoice_amount"
                                        id="invoice_amount"
                                        value={total_amount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          }
                          <CheckButton
                            style={{ display: "none" }}
                            ref={checkBtn}
                          />
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateInvoices;
